"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardColorSource = void 0;
/**
 * 看板颜色设置来源
 */
var CardColorSource;
(function (CardColorSource) {
    CardColorSource["EMPTY"] = "empty";
    CardColorSource["CUSTOM"] = "custom";
    CardColorSource["PROPERTY"] = "property";
})(CardColorSource = exports.CardColorSource || (exports.CardColorSource = {}));
